import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { faqs, faqsEn } from 'src/assets/faqs';
import { FaqService } from 'src/core/index/services.index';
import { FaqItem } from 'src/index';

@Injectable({
    providedIn: 'root'
})
export class FaqServiceCustom extends FaqService {
    translateService = inject(TranslateService);
    override supportEmail = "training@h2iosc.cnr.it";
    override getFaqs() {
        if (this.translateService.currentLang === 'en') {
            return of(faqsEn as FaqItem[]);
        }
        return of(faqs as FaqItem[]);
    }
}
